import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { SimNaoDialogComponent } from "../dialogs/sim-nao-dialog/sim-nao-dialog.component";
import { PreferenciasComponent } from "./preferencias/preferencias.component";
import { EnumPopupType } from "src/app/enums/EnumPopupType";
import { PopupsService } from "./popups.service";

@Component({
  selector: "app-popups",
  templateUrl: "./popups.component.html",
  styleUrls: ["./popups.component.scss"],
})
export class PopupsComponent implements OnInit, OnDestroy {
  @ViewChild(PreferenciasComponent) popupPreferecias: PreferenciasComponent;

  public popupType: EnumPopupType;
  public canClose: boolean;
  public visible: boolean;
  public confirmarAlteracoes: boolean;
  private sPopupType: Subscription;
  private sCanClose: Subscription;
  private sVisible: Subscription;

  constructor(private popupService: PopupsService, public dialog: MatDialog) {}

  ngOnInit(): void {
    this.sPopupType = this.popupService.getPopupType().subscribe((pType) => {
      this.popupType = pType;
    });

    this.sVisible = this.popupService.getVisible().subscribe((v) => {
      this.visible = v;
    });

    this.sCanClose = this.popupService.getCanClose().subscribe((cClose) => {
      this.canClose = cClose;
    });
  }

  ngOnDestroy(): void {
    this.sPopupType.unsubscribe();
    this.sCanClose.unsubscribe();
    this.sVisible.unsubscribe();
  }

  public confirmarAlteracoesChanged(c: boolean): void {
    this.confirmarAlteracoes = c;
  }

  public tryClose(evt: any): void {
    const finalizar = () => {
      this.popupService.fecharPopups();
    };

    evt?.stopPropagation();

    if (!evt?.currentTarget?.classList?.contains("icon-close")) {
      return;
    }

    if (this.confirmarAlteracoes) {
      const dialogRef = this.dialog.open(SimNaoDialogComponent, {
        width: "250px",
        data: "Você possui alterações que não foram salvas. Deseja salvar?",
      });
      dialogRef.afterClosed().subscribe((result) => {
        switch (this.popupType) {
          case EnumPopupType.Preferencias:
            this.popupPreferecias.tentarFechar(result);
            finalizar();

            break;
          default:
            finalizar();
            break;
        }
      });
    } else {
      finalizar();
    }
  }
}
